import { Header } from "./components/Header";
import { SaveTheDate } from "./components/SaveTheDate";
import { Couple } from "./components/Couple";
import { Local } from "./components/Local";
import { Photos } from "./components/Photos";
import { WeddingList } from "./components/WeddingList";
import { Caterers } from "./components/Caterers";
import { Padrinhos } from "./components/Padrinhos";
import { GlobalStyle } from "./styles/global";
import backgroundSet from './assets/img/set.png';
import { Recados } from "./components/Recados";

import { BiChevronUp } from 'react-icons/bi'
import Player from './components/Player';

export function App() {
    function scrollSmoothTo(elementId) {
      var element = document.getElementById(elementId);
      element.scrollIntoView({
          block: 'start',
          behavior: 'smooth'
      });
  }
  return (
    <>
      <Header />
      <SaveTheDate />
      <img src={backgroundSet} style={{ margin: '0 auto', display: 'block', width: 150 }} alt="Divisor" />
      <Couple />
      <img src={backgroundSet} style={{ margin: '0 auto', display: 'block', width: 150 }} alt="Divisor" />
      <Local />
      <img src={backgroundSet} style={{ margin: '0 auto', display: 'block', width: 150 }} alt="Divisor" />
      <Photos />
      <img src={backgroundSet} style={{ margin: '0 auto', display: 'block', width: 150 }} alt="Divisor" />
      <WeddingList />
      <img src={backgroundSet} style={{ margin: '0 auto', display: 'block', width: 150 }} alt="Divisor" />
      <Caterers />
      <img src={backgroundSet} style={{ margin: '0 auto', display: 'block', width: 150 }} alt="Divisor" />
      <Recados />
      <img src={backgroundSet} style={{ margin: '0 auto', display: 'block', width: 150 }} alt="Divisor" />
      <Padrinhos />
      <section>
        <button onClick={() => scrollSmoothTo('header')} style={{ border: '0', background: '#e2799b', display: 'flex', justifyContent: 'center', alignItems: 'center', width: 50, height: 50, borderRadius: '50%', position: 'absolute', right: '30px' }}>
          <BiChevronUp size={30} color="#fff"/>
        </button>
      </section>
      <img src={backgroundSet} style={{ margin: '0 auto', display: 'block', width: 150 }} alt="Divisor" />
      <footer style={{display: 'flex', justifyContent: 'center', margin: '20px auto 45px', fontFamily: 'Josefin Slab'}}>
          <h3>Site desenvolvido pelo noivo</h3>
      </footer>
      <section style={{position: 'fixed', bottom: 0, right: '20px'}}>
        <Player />
      </section>
      <GlobalStyle />
    </>
  );
}
